import { useState } from 'react';
import {
  TBody,
  TableBodyRow,
  TableBodyOpenIconCell,
  EmptyHoveredPlaceholder,
  OpenIcon,
} from './TableBody.styled';
import { CreatedOnCell } from '../Cells/CreatedOnCell/CreatedOnCell';
import { IdCell } from '../Cells/IdCell/IdCell';
import { TicketTypeCell } from '../Cells/TicketTypeCell/TicketTypeCell';
import { CategoryCell } from '../Cells/CategoryCell/CategoryCell';
import { PriorityCell } from '../Cells/PriorityCell/PriorityCell';
import { ApprovalCell } from '../Cells/ApprovalCell/ApprovalCell';
import { OwnerCell } from '../Cells/OwnerCell/OwnerCell';
import { StatusCell } from '../Cells/StatusCell/StatusCell';
import { TitleCell } from '../Cells/TitleCell/TitleCell';
import { useServiceDeskContext } from 'src/context/ServiceDesk/ServiceDeskContext';
import { SingleTicketTransformed } from 'src/components/Tickets/models/Tickets.interface';

export const TableBody = () => {
  const {
    tableHeaderDisplayNameLookUp,
    ticketsDataModified,
    toggleTicketDetails,
  } = useServiceDeskContext();
  const [indexOfHoveredRow, setIndexOfHoveredRow] = useState<number>(-1);

  const handleRowHover = (index: number) => {
    if (index === indexOfHoveredRow) return;
    setIndexOfHoveredRow(index);
  };

  const handleTableBodyLeave = () => {
    setIndexOfHoveredRow(-1);
  };

  return (
    <TBody onMouseLeave={handleTableBodyLeave}>
      {ticketsDataModified &&
        ticketsDataModified.length > 0 &&
        ticketsDataModified?.map((ticket, i) => {
          const isHovered = i === indexOfHoveredRow;
          return (
            <TableBodyRow
              onMouseEnter={() => handleRowHover(i)}
              key={ticket?.new_axsticketid}
              className={isHovered && 'hoveredTaleRow'}
            >
              {Object.keys(tableHeaderDisplayNameLookUp)?.map((columnId) => {
                if (
                  (columnId as keyof SingleTicketTransformed) === 'createdon'
                ) {
                  return (
                    <CreatedOnCell
                      key={`${columnId}_${ticket?.new_axsticketid}`}
                      createdOn={ticket?.createdon}
                    />
                  );
                } else if (
                  (columnId as keyof SingleTicketTransformed) === 'new_id'
                ) {
                  return (
                    <IdCell
                      key={`${columnId}_${ticket?.new_id}`}
                      id={ticket?.new_id}
                    />
                  );
                } else if (
                  (columnId as keyof SingleTicketTransformed) ===
                  'new_description'
                ) {
                  return (
                    <TitleCell
                      key={`${columnId}_${ticket?.new_description}`}
                      description={ticket?.new_description}
                    />
                  );
                } else if (
                  (columnId as keyof SingleTicketTransformed) ===
                  'new_tickettype'
                ) {
                  return (
                    <TicketTypeCell
                      key={`${columnId}_${ticket?.new_tickettype}`}
                      ticketTypeId={ticket?.new_tickettype}
                    />
                  );
                } else if (
                  (columnId as keyof SingleTicketTransformed) ===
                  '_new_category_value'
                ) {
                  return (
                    <CategoryCell
                      key={`${columnId}_${ticket?._new_category_value}`}
                      category={ticket?._new_category_value}
                    />
                  );
                } else if (
                  (columnId as keyof SingleTicketTransformed) === 'new_priority'
                ) {
                  return (
                    <PriorityCell
                      key={`${columnId}_${ticket?.new_priority}`}
                      priority={ticket?.new_priority}
                    />
                  );
                } else if (
                  (columnId as keyof SingleTicketTransformed) ===
                  'new_approvalstatus'
                ) {
                  return (
                    <ApprovalCell
                      hoverPopover
                      key={`${columnId}_${ticket?.new_approvalstatus}`}
                      approval={ticket?.new_approvalstatus}
                    />
                  );
                } else if (
                  (columnId as keyof SingleTicketTransformed) === 'owner'
                ) {
                  return (
                    <OwnerCell
                      key={`${columnId}_${ticket?.owner}`}
                      owner={ticket?.owner}
                    />
                  );
                } else if (
                  (columnId as keyof SingleTicketTransformed) === 'statuscode'
                ) {
                  return (
                    <StatusCell
                      key={`${columnId}_${ticket?.statuscode}`}
                      status={ticket?.statuscode}
                    />
                  );
                }
              })}

              <TableBodyOpenIconCell
                onClick={() =>
                  toggleTicketDetails(
                    ticket.new_axsticketid,
                    ticket?.owner,
                    true
                  )
                }
              >
                {isHovered ? <OpenIcon /> : <EmptyHoveredPlaceholder />}
              </TableBodyOpenIconCell>
            </TableBodyRow>
          );
        })}
    </TBody>
  );
};
